import { z } from "zod";

export const ProHelpContactSchema = z.object({
  subject: z.string().min(3).max(120),
  message: z.string().min(10).max(5000),
});

export type ProHelpContactDto = z.infer<typeof ProHelpContactSchema>;
